import React from 'react';

export default (props) => {
  const bodyRef = React.createRef();
  const createPdf = () => props.createPdf(bodyRef.current);
  return (
    <section className="pdf-container">
      <section className="pdf-toolbar" style={{'float': 'right'}}>
        <button onClick={createPdf} className="btn btn-green dropdown-toggle btn-arrow">Export as PDF</button>
      </section>
      <section className="pdf-body" ref={bodyRef}>
        {props.children}
      </section>
    </section>
  )
}


// WEBPACK FOOTER //
// ./src/components/bewise/Transaction/PdfContainerReports.js